module.exports = __webpack_public_path__ + "media/images/la_punta_de_la_lengua-e992001f16d021321e99ab0b0f9d23de.gif";